var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP1000TipBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.4871 21.04L23.0568 21.0406L23.0569 22.3691L16.4872 22.3686L16.4871 21.04Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 21,
    width: 7,
    height: 43
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8158 21.04L22.7285 21.0405L22.4009 32.333L22.0401 32.333L21.7444 38.3113L21.3907 38.3112L20.4325 63.5559L19.1186 63.5535L18.1564 38.311L17.8026 38.3109L17.5065 32.3326L17.1452 32.3326L16.8158 21.04Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.4875 21.0576L23.057 21.0217L22.7542 32.316L16.9146 32.3479L16.4875 21.0576Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.546 31.6855L23.1156 31.6496L22.9746 38.2931L16.7602 38.3271L16.546 31.6855Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.8928 37.6572L21.8345 37.6357L20.6633 63.5487L19.3494 63.5559L17.8928 37.6572Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.447 63.5541L18.1335 21.7134L16.8196 21.7206L16.4908 63.5594L19.447 63.5541Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.104 63.5503L21.4183 21.6952L22.7322 21.688L23.0603 63.5506L20.104 63.5503Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0572 22.3693L16.4875 22.3691L16.495 23.0509L23.0571 23.0332L23.0572 22.3693ZM16.6499 32.3503L22.4623 32.3181L22.4459 32.9822L16.5533 33.0147L16.6499 32.3503ZM17.9622 38.3214L21.7726 38.3004L21.763 38.9645L17.9001 38.9858L17.9622 38.3214Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.8039 20.8916L50.3735 20.8921L50.3736 22.2207L43.804 22.2201L43.8039 20.8916Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 20,
    width: 7,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1326 20.8916L50.0453 20.8921L49.7177 32.1846L49.3569 32.1845L49.0611 38.1628L48.7074 38.1628L47.7493 63.4074L46.4353 63.4051L45.4732 38.1625L45.1193 38.1625L44.8233 32.1842L44.462 32.1841L44.1326 20.8916Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.8043 20.9092L50.3738 20.8733L50.071 32.1676L44.2314 32.1995L43.8043 20.9092Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.8628 31.5371L50.4323 31.5012L50.2914 38.1447L44.0769 38.1787L43.8628 31.5371Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M45.2096 37.5088L49.1513 37.4872L47.9801 63.4003L46.6662 63.4075L45.2096 37.5088Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.7638 63.4057L45.4503 21.565L44.1364 21.5721L43.8076 63.4109L46.7638 63.4057Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.4208 63.4019L48.7351 21.5468L50.049 21.5396L50.3771 63.4021L47.4208 63.4019Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.374 22.2208L43.8043 22.2207L43.8118 22.9025L50.3739 22.8848L50.374 22.2208ZM43.9667 32.2018L49.7791 32.1697L49.7626 32.8337L43.8701 32.8663L43.9667 32.2018ZM45.279 38.173L49.0893 38.1519L49.0798 38.816L45.2169 38.8374L45.279 38.173Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.8082 20.9619L37.3778 20.9624L37.3779 22.291L30.8083 22.2904L30.8082 20.9619Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 20,
    width: 7,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1368 20.9619L37.0496 20.9624L36.722 32.2549L36.3612 32.2548L36.0654 38.2331L35.7117 38.2331L34.7535 63.4778L33.4396 63.4754L32.4775 38.2328L32.1236 38.2328L31.8276 32.2545L31.4662 32.2544L31.1368 20.9619Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.8085 20.9795L37.3781 20.9436L37.0753 32.2379L31.2357 32.2698L30.8085 20.9795Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.8671 31.6074L37.4366 31.5715L37.2957 38.215L31.0812 38.249L30.8671 31.6074Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M32.2139 37.5791L36.1556 37.5576L34.9843 63.4706L33.6704 63.4778L32.2139 37.5791Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.768 63.476L32.4546 21.6353L31.1407 21.6425L30.8118 63.4812L33.768 63.476Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M34.4251 63.4722L35.7393 21.6171L37.0533 21.6099L37.3814 63.4724L34.4251 63.4722Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3783 22.2911L30.8085 22.291L30.8161 22.9728L37.3781 22.9551L37.3783 22.2911ZM30.9709 32.2721L36.7833 32.24L36.7669 32.904L30.8743 32.9366L30.9709 32.2721ZM32.2832 38.2433L36.0936 38.2222L36.0841 38.8863L32.2212 38.9077L32.2832 38.2433Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.5371 19.4785L26.704 19.4791L26.7041 20.9284L19.5372 20.9278L19.5371 19.4785Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 8,
    height: 47
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8956 19.4785L26.3459 19.479L25.9885 31.7981L25.5949 31.7981L25.2722 38.3198L24.8864 38.3198L23.8411 65.8594L22.4077 65.8569L21.3581 38.3195L20.9721 38.3195L20.6492 31.7977L20.255 31.7976L19.8956 19.4785Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.5375 19.498L26.7042 19.4589L26.3739 31.7799L20.0035 31.8148L19.5375 19.498Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.6013 31.0928L26.7681 31.0536L26.6143 38.301L19.8349 38.3381L19.6013 31.0928Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.0706 37.6064L25.3706 37.5829L24.0929 65.8517L22.6595 65.8596L21.0706 37.6064Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.766 65.8569L21.3332 20.2125L19.8998 20.2203L19.5411 65.8626L22.766 65.8569Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.4828 65.8531L24.9166 20.193L26.3499 20.1852L26.7079 65.8534L23.4828 65.8531Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7045 20.9288L19.5375 20.9287L19.5457 21.6725L26.7043 21.6532L26.7045 20.9288ZM19.7146 31.8172L26.0555 31.7822L26.0375 32.5066L19.6093 32.5421L19.7146 31.8172ZM21.1463 38.3312L25.303 38.3082L25.2926 39.0327L21.0785 39.056L21.1463 38.3312Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M33.8583 19.3994L41.0252 19.4L41.0253 20.8493L33.8585 20.8487L33.8583 19.3994Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 19,
    width: 7,
    height: 47
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2169 19.3994L40.6671 19.3999L40.3097 31.719L39.9161 31.719L39.5935 38.2407L39.2076 38.2407L38.1623 65.7803L36.729 65.7778L35.6794 38.2404L35.2933 38.2404L34.9704 31.7186L34.5762 31.7185L34.2169 19.3994Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.8587 19.4189L41.0255 19.3798L40.6952 31.7008L34.3247 31.7356L33.8587 19.4189Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.9225 31.0137L41.0893 30.9745L40.9356 38.2219L34.1561 38.259L33.9225 31.0137Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.3918 37.5273L39.6918 37.5038L38.4141 65.7726L36.9808 65.7805L35.3918 37.5273Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.0873 65.7778L35.6544 20.1334L34.2211 20.1412L33.8623 65.7835L37.0873 65.7778Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.804 65.774L39.2378 20.1139L40.6712 20.1061L41.0291 65.7743L37.804 65.774Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0257 20.8497L33.8587 20.8496L33.8669 21.5934L41.0256 21.5741L41.0257 20.8497ZM34.0359 31.7381L40.3767 31.7031L40.3588 32.4275L33.9305 32.463L34.0359 31.7381ZM35.4675 38.2521L39.6242 38.2291L39.6139 38.9536L35.3998 38.9769L35.4675 38.2521Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.4147 19.3262L54.5816 19.3267L54.5817 20.776L47.4148 20.7755L47.4147 19.3262Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 19,
    width: 8,
    height: 47
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7733 19.3262L54.2235 19.3267L53.8661 31.6458L53.4725 31.6457L53.1499 38.1675L52.764 38.1675L51.7187 65.7071L50.2854 65.7045L49.2358 38.1672L48.8497 38.1672L48.5268 31.6453L48.1326 31.6453L47.7733 19.3262Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.4151 19.3457L54.5819 19.3065L54.2516 31.6276L47.8811 31.6624L47.4151 19.3457Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.4789 30.9404L54.6457 30.9012L54.492 38.1487L47.7125 38.1858L47.4789 30.9404Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.9482 37.4541L53.2482 37.4306L51.9705 65.6994L50.5372 65.7072L48.9482 37.4541Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.6436 65.7046L49.2108 20.0601L47.7774 20.068L47.4187 65.7103L50.6436 65.7046Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.3604 65.7008L52.7942 20.0406L54.2275 20.0328L54.5855 65.701L51.3604 65.7008Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5821 20.7765L47.4151 20.7764L47.4233 21.5202L54.582 21.5008L54.5821 20.7765ZM47.5923 31.6649L53.9331 31.6298L53.9152 32.3542L47.4869 32.3897L47.5923 31.6649ZM49.0239 38.1789L53.1806 38.1559L53.1703 38.8804L48.9562 38.9037L49.0239 38.1789Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.47424 17.2148L17.1189 17.2155L17.119 18.7855L9.47437 18.7849L9.47424 17.2148Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 17,
    width: 8,
    height: 51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85663 17.2148L16.7369 17.2154L16.3557 30.5611L15.9359 30.561L15.5917 37.6263L15.1801 37.6262L14.0652 67.4608L12.5363 67.4581L11.4167 37.6259L11.0049 37.6259L10.6604 30.5606L10.2399 30.5606L9.85663 17.2148Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.47461 17.2363L17.1192 17.1939L16.7668 30.5417L9.97168 30.5794L9.47461 17.2363Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.54272 29.7969L17.1873 29.7544L17.0233 37.6058L9.79191 37.646L9.54272 29.7969Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.11 36.8535L15.6967 36.828L14.3338 67.4526L12.8049 67.4611L11.11 36.8535Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M12.9184 67.4585L11.39 18.0104L9.86108 18.0188L9.47851 67.4647L12.9184 67.4585Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.683 67.4547L15.2123 17.9896L16.7412 17.9811L17.1231 67.455L13.683 67.4547Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1194 18.7856L9.47467 18.7861L9.48339 19.5912L17.1192 19.5696L17.1194 18.7856ZM9.6636 30.5819L16.4272 30.5434L16.408 31.3275L9.55113 31.3666L9.6636 30.5819ZM11.1907 37.6385L15.6246 37.6133L15.6135 38.3977L11.1184 38.4233L11.1907 37.6385Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.9989 17.1348L31.6436 17.1354L31.6437 18.7055L23.999 18.7048L23.9989 17.1348Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 17,
    width: 8,
    height: 51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3813 17.1348L31.2616 17.1353L30.8803 30.481L30.4605 30.4809L30.1164 37.5462L29.7048 37.5462L28.5899 67.3808L27.0609 67.378L25.9413 37.5459L25.5296 37.5458L25.1851 30.4805L24.7646 30.4805L24.3813 17.1348Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.9993 17.1562L31.6438 17.1138L31.2915 30.4616L24.4963 30.4993L23.9993 17.1562Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M24.0674 29.7168L31.7119 29.6743L31.548 37.5258L24.3166 37.5659L24.0674 29.7168Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.6346 36.7734L30.2214 36.748L28.8585 67.3725L27.3296 67.381L25.6346 36.7734Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.4431 67.3784L25.9147 17.9303L24.3857 17.9388L24.0032 67.3846L27.4431 67.3784Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M28.2076 67.3747L29.7369 17.9095L31.2659 17.901L31.6478 67.3749L28.2076 67.3747Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6441 18.7055L23.9993 18.7061L24.0081 19.5111L31.6438 19.4895L31.6441 18.7055ZM24.1883 30.5018L30.9519 30.4633L30.9327 31.2474L24.0758 31.2865L24.1883 30.5018ZM25.7153 37.5585L30.1493 37.5332L30.1381 38.3176L25.643 38.3433L25.7153 37.5585Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M37.7591 17.0596L45.4038 17.0602L45.4039 18.6303L37.7592 18.6296L37.7591 17.0596Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 17,
    width: 8,
    height: 51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1415 17.0596L45.0218 17.0601L44.6405 30.4058L44.2207 30.4058L43.8766 37.471L43.465 37.471L42.3501 67.3056L40.8211 67.3028L39.7015 37.4707L39.2898 37.4706L38.9453 30.4053L38.5248 30.4053L38.1415 17.0596Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.7595 17.0811L45.404 17.0386L45.0517 30.3864L38.2565 30.4242L37.7595 17.0811Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.8276 29.6416L45.4721 29.5991L45.3081 37.4506L38.0768 37.4907L37.8276 29.6416Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.3948 36.6982L43.9816 36.6728L42.6187 67.2973L41.0898 67.3058L39.3948 36.6982Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M41.2033 67.3033L39.6748 17.8551L38.1459 17.8636L37.7634 67.3094L41.2033 67.3033Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M41.9678 67.2995L43.4971 17.8343L45.0261 17.8258L45.4079 67.2997L41.9678 67.2995Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4043 18.6303L37.7595 18.6309L37.7682 19.436L45.404 19.4143L45.4043 18.6303ZM37.9484 30.4266L44.712 30.3881L44.6929 31.1723L37.836 31.2113L37.9484 30.4266ZM39.4755 37.4833L43.9095 37.458L43.8983 38.2424L39.4032 38.2681L39.4755 37.4833Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M52.2838 16.9805L59.9284 16.9811L59.9286 18.5512L52.2839 18.5505L52.2838 16.9805Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 16,
    width: 8,
    height: 52
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6661 16.9805L59.5464 16.981L59.1652 30.3267L58.7454 30.3267L58.4012 37.3919L57.9896 37.3919L56.8747 67.2265L55.3458 67.2237L54.2262 37.3916L53.8144 37.3915L53.4699 30.3262L53.0494 30.3262L52.6661 16.9805Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.2841 17.002L59.9287 16.9595L59.5764 30.3073L52.7812 30.345L52.2841 17.002Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.3522 29.5625L59.9968 29.52L59.8328 37.3715L52.6014 37.4116L52.3522 29.5625Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.9195 36.6191L58.5062 36.5937L57.1433 67.2182L55.6144 67.2267L53.9195 36.6191Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.7279 67.2242L54.1995 17.776L52.6706 17.7845L52.288 67.2303L55.7279 67.2242Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.4925 67.2204L58.0218 17.7552L59.5507 17.7467L59.9326 67.2206L56.4925 67.2204Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9289 18.5512L52.2842 18.5518L52.2929 19.3568L59.9287 19.3352L59.9289 18.5512ZM52.4731 30.3475L59.2367 30.309L59.2175 31.0932L52.3606 31.1322L52.4731 30.3475ZM54.0002 37.4042L58.4341 37.3789L58.423 38.1633L53.9279 38.189L54.0002 37.4042Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72275 29.8322C6.6182 29.8382 5.72771 30.7385 5.73379 31.8431L5.76136 36.8497L3.1746 36.8638C2.07005 36.8699 1.17956 37.7702 1.18564 38.8747L1.19178 39.9888L5.82773 39.9634C6.03419 40.8537 6.83472 41.515 7.78705 41.5098L61.8857 41.214C62.8381 41.2088 63.6313 40.5388 63.8279 39.6463L69.2283 39.6168L69.2222 38.5027C69.2161 37.3982 68.3158 36.5077 67.2112 36.5137L63.86 36.532L63.8324 31.5254C63.8263 30.4209 62.926 29.5303 61.8214 29.5364L7.72275 29.8322Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5666 36.5446L8.05473 36.8371L7.76133 36.8387L5.76136 36.8497L5.75035 34.8497L5.74422 33.7356L5.73379 31.8431C5.72771 30.7385 6.6182 29.8382 7.72275 29.8322L8.01615 29.8306L8.03758 33.7231L61.5495 33.4305L61.528 29.538L61.8214 29.5364C62.926 29.5303 63.8263 30.4209 63.8324 31.5254L63.8428 33.418L63.849 34.5321L63.86 36.532L61.86 36.543L61.5666 36.5446ZM1.18564 38.8747C1.17956 37.7702 2.07005 36.8699 3.1746 36.8638L3.468 36.8622L3.48514 39.9763L1.19178 39.9888L1.18564 38.8747ZM67.2112 36.5137L66.9178 36.5153L66.935 39.6294L69.2283 39.6168L69.2222 38.5028C69.2161 37.3982 68.3157 36.5077 67.2112 36.5137Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6149 41.6881C66.5317 41.9404 66.4306 42.2636 66.3165 42.661C65.9951 43.7811 65.5705 45.4914 65.1506 47.87C64.3239 52.5529 63.5152 59.8267 63.5465 70.2891L54.9703 70.336L53.1458 69.6044L53.0549 69.568L52.957 69.5685L17.0275 69.7649L16.9296 69.7655L16.8391 69.8029L15.0228 70.5544L7.2111 70.5971C7.13077 60.3279 6.33669 53.0686 5.55392 48.3523C5.15621 45.956 4.76143 44.2162 4.46467 43.0716C4.35305 42.6411 4.2553 42.2948 4.17649 42.0295L66.6149 41.6881Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48944 40.7549C3.48944 40.7549 6.59442 49.3018 6.71016 70.3215L15.1192 70.2756L17.026 69.4866L52.9554 69.2902L54.8709 70.0582L64.0443 70.0081C63.9264 48.5991 66.9393 40.408 66.9393 40.408",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19177 39.9883L69.2283 39.6163V39.6163C69.2331 40.4762 68.5398 41.1771 67.6799 41.1818L2.75737 41.5368C1.89745 41.5415 1.19651 40.8482 1.19177 39.9883V39.9883Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3377 69.2875L53.2652 56.1282C53.2434 52.1603 48.0651 45.9603 35.0336 46.0316C22.0021 46.1028 16.5495 52.3609 16.5713 56.3288L16.6438 69.4881",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 15.2893,
    height: 4.67113,
    rx: 1,
    transform: "matrix(0.999985 -0.00546715 0.00550633 0.999985 27.2047 43.7393)",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1615 6.0919L16.4392 6.64967L17.0622 6.64627L51.845 6.4561L52.3504 6.45334L52.6479 6.04471L53.4885 4.89005L65.0245 4.82698L66.6289 35.5166L2.98141 35.8646L4.24777 5.15926L15.6662 5.09683L16.1615 6.0919Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2922 5.65039L17.8554 11.8701",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9861 5.4502L51.4915 11.6866",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4122 6.39551L46.8747 6.26177L46.9023 11.2684C46.9084 12.3729 46.0179 13.2732 44.9134 13.2793L24.4507 13.3912C23.3462 13.3972 22.4458 12.5067 22.4397 11.4021L22.4122 6.39551Z",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.00549,
    y: 0.994518,
    width: 14.8183,
    height: 13.5704,
    rx: 2,
    transform: "matrix(0.999985 -0.00546715 0.00550633 0.999985 26.3876 35.1852)",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.5665,
    height: 69.57,
    fill: "white",
    transform: "translate(0.211426 0.918945) rotate(-0.314367)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.5665,
    height: 108.215,
    fill: "white",
    transform: "matrix(0.999985 -0.00546715 0.00550633 0.999985 0.00292969 -37.0801)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 8.05181e-05 7.99184e-05 1 16.4872 21.04)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 8.05181e-05 7.99184e-05 1 16.4872 21.04)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 8.05158e-05 7.99161e-05 1 43.804 20.8916)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 8.05158e-05 7.99161e-05 1 43.804 20.8916)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 8.05158e-05 7.99161e-05 1 30.8083 20.9619)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 8.05158e-05 7.99161e-05 1 30.8083 20.9619)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3777,
    fill: "white",
    transform: "matrix(1 8.05185e-05 7.99187e-05 1 19.5372 19.4785)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3777,
    fill: "white",
    transform: "matrix(1 8.05185e-05 7.99187e-05 1 19.5372 19.4785)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3777,
    fill: "white",
    transform: "matrix(1 8.0517e-05 7.99173e-05 1 33.8585 19.3994)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3777,
    fill: "white",
    transform: "matrix(1 8.0517e-05 7.99173e-05 1 33.8585 19.3994)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3777,
    fill: "white",
    transform: "matrix(1 8.05166e-05 7.99169e-05 1 47.4149 19.3262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3777,
    fill: "white",
    transform: "matrix(1 8.05166e-05 7.99169e-05 1 47.4149 19.3262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64467,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05169e-05 7.99172e-05 1 9.47437 17.2148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64467,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05169e-05 7.99172e-05 1 9.47437 17.2148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64467,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05156e-05 7.99159e-05 1 23.999 17.1348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64467,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05156e-05 7.99159e-05 1 23.999 17.1348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05152e-05 7.99155e-05 1 37.7592 17.0596)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05152e-05 7.99155e-05 1 37.7592 17.0596)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05143e-05 7.99146e-05 1 52.2839 16.9805)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 8.05143e-05 7.99146e-05 1 52.2839 16.9805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1000TipBox);
export default __webpack_public_path__ + "static/media/P1000_Tip_Box.1d84ffaadf35bf841688eb16619604e0.svg";
export { ForwardRef as ReactComponent };